import { useState } from 'react';
import { useAuth } from '../../auth/AuthContext';
import { SchoolSelect } from '../../components/common';
import { t, type MessageKey } from '../../i18n';
import { ExamsTab } from './ExamsTab';
import { GradingTab } from './GradingTab';
import { ResultsTab } from './ResultsTab';

type Tab = 'exams' | 'grading' | 'results';

export function ExamsPage() {
  const { can } = useAuth();
  const [schoolId, setSchoolId] = useState('');
  const [tab, setTab] = useState<Tab>('exams');
  const tabs: Tab[] = ['exams'];
  if (schoolId && can('grading.view', schoolId)) tabs.push('grading');
  if (schoolId && can('results.view', schoolId)) tabs.push('results');

  return (
    <div className="mx-auto max-w-5xl space-y-4">
      <h1 className="text-2xl font-bold">{t('exam.title')}</h1>
      <SchoolSelect value={schoolId} onChange={setSchoolId} />
      {schoolId && (
        <>
          <div
            role="tablist"
            aria-label={t('exam.title')}
            className="flex flex-wrap gap-1 border-b border-slate-200"
          >
            {tabs.map((name) => (
              <button
                key={name}
                role="tab"
                type="button"
                aria-selected={tab === name}
                onClick={() => setTab(name)}
                className={`-mb-px border-b-2 px-4 py-2 text-sm font-medium ${tab === name ? 'border-brand-700 text-brand-700' : 'border-transparent text-slate-600'}`}
              >
                {t(`exam.tab.${name}` as MessageKey)}
              </button>
            ))}
          </div>
          <div role="tabpanel">
            {tab === 'exams' && <ExamsTab schoolId={schoolId} />}
            {tab === 'grading' && <GradingTab schoolId={schoolId} />}
            {tab === 'results' && <ResultsTab schoolId={schoolId} />}
          </div>
        </>
      )}
    </div>
  );
}
